(function () {
  const btn = document.getElementById('BackToTop');
  const grid = document.getElementById('product-grid');
  if (!btn || !grid) return;

  const SCROLL_THRESHOLD = 400;

  function toggleVisibility() {
    const show = window.scrollY > SCROLL_THRESHOLD;
    btn.hidden = !show;
    btn.classList.toggle('is-visible', show);
  }

  function scrollToTop() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  }

  btn.addEventListener('click', scrollToTop);
  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();
})();
